module.exports = __webpack_public_path__ + "img/gartentor.ab5dcee2.webp";